import { render, staticRenderFns } from "./space-exam-compose.vue?vue&type=template&id=4b2eadd9&scoped=true"
import script from "./space-exam-compose.vue?vue&type=script&lang=js"
export * from "./space-exam-compose.vue?vue&type=script&lang=js"
import style0 from "./space-exam-compose.vue?vue&type=style&index=0&id=4b2eadd9&prod&lang=less&scoped=true"
import style1 from "./space-exam-compose.vue?vue&type=style&index=1&id=4b2eadd9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2eadd9",
  null
  
)

export default component.exports